module.exports = __webpack_public_path__ + "img/antes_despues_26.f6542ad7.png";